import { useFormContext, useController } from 'react-hook-form';
import styled from 'styled-components';
import { FormField } from 'ui/formField';
import { InputText } from 'ui/inputs';
import { caption, colors, fontWeights } from 'ui/theme';
import { SnippetFieldTestingIds, SnippetFieldsInputIds } from '../../types';
import { useTranslations } from '../../hooks/useTranslations';
import { getRemainingCharactersText } from '../../utils';

const BoldCaption = styled.span`
  ${caption};
  color: ${colors.textSecondary};
  font-weight: ${fontWeights.bold};
`;

export const SnippetName = () => {
  const {
    watch,
    formState: { errors },
  } = useFormContext();
  const fieldIdentifier = SnippetFieldsInputIds.name;
  const snippetName = watch(fieldIdentifier);
  const {
    field: { onChange, onBlur, value },
  } = useController({ name: fieldIdentifier, defaultValue: snippetName });
  const { t } = useTranslations();

  const handleChange = (newSnippetName: string) => {
    onChange(newSnippetName);
  };

  return (
    <FormField
      errorText={<>{errors[fieldIdentifier]?.message}</>}
      hasError={fieldIdentifier in errors}
      helpText={
        <>
          <BoldCaption>{t('input.snippetName.helpTextBold')}</BoldCaption>
          {` ${t('input.snippetName.helpText')}`}
        </>
      }
      inputId={SnippetFieldTestingIds.Name}
      labelText={t('label.snippetName')}
      restrictionText={getRemainingCharactersText(100, snippetName.length)}
    >
      <InputText
        data-test={SnippetFieldTestingIds.Name}
        id={SnippetFieldTestingIds.Name}
        maxLength={100}
        placeholder={t('input.snippetName.placeholder')}
        type="text"
        value={value}
        onChange={handleChange}
        onBlur={onBlur}
      />
    </FormField>
  );
};
